import { Typography } from "antd"

function GroundOperationComponent() {
    return (
        <>
            <Typography.Title level={4} > Ground Operation </Typography.Title>
            <div
                style={{
                    margin: "auto",
                    width: "60%",
                }}
            >
                <iframe src="/Ground Operations - Version 03.pdf" width="900" height="700"></iframe>
            </div>
        </>
    )
}
export default GroundOperationComponent